import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Typography, Toolbar } from '@mui/material';
import LocaleMenu from './LocaleMenu';
import UserMenu from './UserMenu';

let NavBar = () => {
    return (
        <AppBar elevation={0} position="sticky">
            <Toolbar variant="dense" >
                <RouterLink to="/">
                    <img alt="Simec My" style={{ width: 40, textAlign: 'center' }} src="/images/logo_ipad.png" />
                </RouterLink>
                {process.env.REACT_APP_ENVIRONMENT === "staging" &&
                    <Typography component="span" style={{ color: '#354249' }}>
                        <strong>Staging env.</strong>
                    </Typography>
                }

                <div style={{ flexGrow: 1 }} />
                <LocaleMenu />
                <UserMenu />
            </Toolbar>
        </AppBar>
    )
}

export default NavBar;